import React from 'react';
import cn from 'clsx';

import { UIText3, ArticleHeading5, ArticleHeading4, ArticleParagraph2, useDeviceType } from '@cian/ui-kit';

import { ETestIds } from '../../constants/testIds';

import styles from './styles.css';
import { PERCENT, NBSP } from '../../../common/constants';

interface IDownPaymentProps {
  requiredAmountCash: string;
  downPayment: string;
  commission: string;
  discountPercentBySeller: string;
  necessarySumInPercent: number;
}

export const DownPayment: React.FC<IDownPaymentProps> = ({
  requiredAmountCash,
  downPayment,
  commission,
  discountPercentBySeller,
  necessarySumInPercent,
}) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['root'], styles[deviceType])}>
      <div className={styles['up-block']}>
        <ArticleHeading5>Необходимая сумма</ArticleHeading5>
        <div>
          <ArticleHeading4 data-testid={ETestIds.RequiredAmountCash}>{requiredAmountCash} ₽</ArticleHeading4>
        </div>
        <UIText3>
          <span className={styles['gray']}>
            Единоразовый взнос при{NBSP}оформлении ипотеки ({necessarySumInPercent}%{NBSP}от{NBSP}стоимости квартиры)
          </span>
        </UIText3>
      </div>
      <div className={styles['down-block']}>
        <ArticleParagraph2>Как распределяются средства</ArticleParagraph2>
        <div className={cn(styles['down-block-content'], styles[deviceType])}>
          <div className={cn(styles['text-segment'], styles[deviceType])}>
            <div className={styles['text-segment-title']}>
              <ArticleParagraph2>
                <span className={styles['gray']}>Первоначальный взнос</span>
              </ArticleParagraph2>
            </div>
            <ArticleHeading4 data-testid={ETestIds.DownPayment}>{downPayment} ₽</ArticleHeading4>
          </div>
          <div className={cn(styles['text-segment'], styles[deviceType])}>
            <div className={styles['text-segment-title']}>
              <ArticleParagraph2>
                <span className={styles['gray']}>Комиссия за снижение ставки</span>
              </ArticleParagraph2>
            </div>
            <ArticleHeading4 data-testid={ETestIds.Commission}>{commission} ₽</ArticleHeading4>
            <UIText3>
              <span className={styles['gray']}>
                Оплачивает покупатель за счёт скидки {discountPercentBySeller}
                {PERCENT}
                {NBSP}от{NBSP}продавца
              </span>
            </UIText3>
          </div>
        </div>
      </div>
    </div>
  );
};
